module.exports = __webpack_public_path__ + "static/media/courseB.1518fd81.png";